export const iconFontAwesomeDesignCompassDrafting = (
	<i className="fa-solid fa-compass-drafting"></i>
);
